import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import storage from '../../utils/persistentStorage';

const API = process.env.REACT_APP_BACKEND_URL || '';

/**
 * Phase 18: Public Onboarding - Completion Screen
 * Final step: Mark onboarding complete and navigate to dashboard
 */
function PublicOnboardingFinish() {
  const navigate = useNavigate();

  useEffect(() => {
    const completeOnboarding = async () => {
      try {
        const token = await storage.getItem('family_token');
        if (token) {
          // Mark onboarding as complete
          await axios.post(
            `${API}/api/family/onboarding/complete`,
            {},
            { headers: { Authorization: `Bearer ${token}` } }
          );
          console.log('✅ Onboarding marked as complete');
        }
      } catch (err) {
        console.error('Error completing onboarding:', err);
      } finally {
        // Cleanup session storage
        sessionStorage.removeItem('onboarding_household_id');
        sessionStorage.removeItem('onboarding_user_id');
        sessionStorage.removeItem('onboarding_device_id');
      }
    };

    completeOnboarding();
  }, []);

  const handleGoToDashboard = async () => {
    // Ensure onboarding is marked complete before navigating
    try {
      const token = await storage.getItem('family_token');
      if (token) {
        await axios.post(
          `${API}/api/family/onboarding/complete`,
          {},
          { headers: { Authorization: `Bearer ${token}` } }
        );
      }
    } catch (err) {
      console.error('Error completing onboarding:', err);
    }
    
    // Force reload to refresh auth context
    window.location.href = '/family/dashboard';
  };

  return (
    <div className="min-h-screen bg-[#050816] flex items-center justify-center p-4">
      <div className="w-full max-w-2xl">
        {/* Success Animation */}
        <div className="text-center mb-8 animate-fade-in">
          <div className="inline-flex items-center justify-center w-32 h-32 rounded-full bg-gradient-to-br from-[#22C55E] to-[#16a34a] mb-6 shadow-2xl animate-scale-in">
            <span className="text-7xl">✓</span>
          </div>
          <h1 className="text-5xl font-bold text-[#F9FAFB] mb-3">
            Alles bereit!
          </h1>
          <p className="text-xl text-[#6DCEE8] mb-6">
            Ihr Hayat System ist jetzt eingerichtet
          </p>
        </div>

        {/* Info Cards */}
        <div className="grid gap-4 mb-8">
          <div className="bg-neutral-900/80 backdrop-blur-xl rounded-xl p-6 shadow-xl border border-neutral-600/40 flex items-start gap-4">
            <span className="text-3xl">🏠</span>
            <div>
              <h3 className="text-lg font-bold text-[#F9FAFB] mb-1">Haushalt erstellt</h3>
              <p className="text-sm text-neutral-400">Ihr Haushalt wurde erfolgreich angelegt</p>
            </div>
          </div>
          <div className="bg-neutral-900/80 backdrop-blur-xl rounded-xl p-6 shadow-xl border border-neutral-600/40 flex items-start gap-4">
            <span className="text-3xl">👤</span>
            <div>
              <h3 className="text-lg font-bold text-[#F9FAFB] mb-1">Administrator-Account</h3>
              <p className="text-sm text-neutral-400">Sie wurden als Administrator registriert</p>
            </div>
          </div>
          <div className="bg-neutral-900/80 backdrop-blur-xl rounded-xl p-6 shadow-xl border border-neutral-600/40 flex items-start gap-4">
            <span className="text-3xl">📱</span>
            <div>
              <h3 className="text-lg font-bold text-[#F9FAFB] mb-1">Bereit zum Loslegen</h3>
              <p className="text-sm text-neutral-400">Sie können jetzt Senioren verwalten und Video-Anrufe starten</p>
            </div>
          </div>
        </div>

        {/* CTA */}
        <button
          onClick={handleGoToDashboard}
          className="w-full py-5 bg-gradient-to-r from-[#6DCEE8] to-[#5ab4cc] text-[#050816] rounded-xl font-bold text-xl shadow-lg hover:shadow-xl hover:scale-105 active:scale-95 transition-all duration-300"
        >
          🚀 Zum Dashboard
        </button>

        {/* Footer */}
        <p className="text-center text-sm text-neutral-500 mt-8">
          Willkommen in der Hayat Familie! 💙
        </p>
      </div>
    </div>
  );
}

export default PublicOnboardingFinish;
